import React, { useEffect, useState } from "react";
import "./style.css";
import { scrollx_animate_black } from "../../../assets/icons";

const PageContentDetails = ({
  selectedHeading,
  currPageContent,
  setCurrPageContent,
  secondaryHeading,
  tertiarySubHeading,
  loadPageContent,
}) => {
  const [subContent, setSubContent] = useState([]);
  useEffect(() => {
    const contentContainer = document.getElementById("contentFind");
    if (contentContainer) {
      const h2Elements = contentContainer.querySelectorAll("h2");
      const h2Texts = [];
      h2Elements.forEach((h2) => {
        h2Texts.push(h2.textContent);
      });
      setSubContent(h2Texts);
    } else {
      setSubContent([]);
    }
  }, [currPageContent]);

  if (loadPageContent) {
    return (
      <div className="w-[79%] h-[80%] flex items-center justify-center">
        <img src={scrollx_animate_black} className="w-[120px] h-[120px]" />
      </div>
    );
  }

  return (
    <div className="flex h-[94%] w-full bg-[#fff] overflow-auto HelperPageContentScroll">
      <div className="w-[79%] flex flex-col items-start h-full px-[4%]">
        <div className="w-[71%] mx-auto my-5">
          <div className=" ">
            {secondaryHeading && (
              <div className="flex items-center text-2xl text-[#707070] py-1">
                <h1 className="w-full text-left  FontFamily-Avenir">
                  {secondaryHeading}
                </h1>
              </div>
            )}
            {tertiarySubHeading && (
              <h4
                className={`cursor-pointer pb-2 pt-7 text-[26px] FontFamily-Avenir  text-[#505256]`}
              >
                {tertiarySubHeading}
              </h4>
            )}
          </div>

          {loadPageContent ? (
            <div className="flex justify-center items-center h-full">
              <div className="loader"></div>
            </div>
          ) : (
            <div className="text-[#707070] text-base leading-relaxed  content-area MainContent-helper">
              <div
                className="quill-content"
                id="contentFind"
                dangerouslySetInnerHTML={{ __html: currPageContent }}
              />
            </div>
          )}

          {currPageContent === "" && !loadPageContent && (
            <div className="text-center mt-10 text-gray-500">
              No content available for this section.
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PageContentDetails;
